import { call } from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import { takeLatest, put } from 'redux-saga/effects';
import {getDashboardData, dashboardDataSuccess, dashboardDataFailed} from "../slices/adminDashboardSlice";

const endpoint = '/admin/dashboard';

function* fetchDashboardData() {
    try {
        const response = yield call(HttpService.get, endpoint);
        const { data } = response.data;
        if (data) {
            yield put(dashboardDataSuccess(data));
        }
    } catch (error) {
        yield put(dashboardDataFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getDashboardData.type, fetchDashboardData);
}
